import { render, staticRenderFns } from "./bookingreport.vue?vue&type=template&id=ba044728"
import script from "./bookingreport.vue?vue&type=script&lang=js"
export * from "./bookingreport.vue?vue&type=script&lang=js"
import style0 from "./bookingreport.vue?vue&type=style&index=0&id=ba044728&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports